import { render, staticRenderFns } from "./AdminChat.vue?vue&type=template&id=9dcf45fa&scoped=true"
import script from "./AdminChat.vue?vue&type=script&lang=js"
export * from "./AdminChat.vue?vue&type=script&lang=js"
import style0 from "./AdminChat.vue?vue&type=style&index=0&id=9dcf45fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dcf45fa",
  null
  
)

export default component.exports